/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.score-button-dropdown-list {
  .score-button-dropdown {
    width: 100%;
    height: variables.$score-button-height;
    margin-bottom: variables.$gap-score-button-lists;

    .title {
      color: variables.$color-black;
      min-width: 100px;
    }

    .MuiAutocomplete-inputRoot {
      flex-wrap: nowrap;
      height: variables.$score-button-height;
    }

    .MuiFormControl-root.MuiFormControl-fullWidth {
      margin-top: 0;
    }
    .MuiInputBase-root:hover {
      background-color: variables.$color-lightgrey;
      fieldset {
        border: 1px solid variables.$color-black-20;
      }
    }

    .MuiButtonBase-root.Mui-selected {
      color: variables.$color-white;
      border: 1px solid transparent;

      .option {
        .score {
          background: variables.$color-darkorange;
        }

        .label {
          background: variables.$color-orange;
        }
      }
    }
  }
}

.score-button-dropdown-item {
  @include mixins.use-available-space;

  border-radius: 4px;
  border: 1px solid variables.$color-corpuls-secondary-50;
  overflow: hidden;
  position: relative;
  isolation: isolate;
  height: variables.$score-button-height-small;
  min-width: 200px;

  .option {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    height: variables.$score-button-height-small;
    mix-blend-mode: multiply;

    .score {
      border-right: 1px solid variables.$color-corpuls-secondary-50;
      font-size: variables.$score-button-font-size;
      font-weight: 500;
      line-height: variables.$score-button-height-small;
      width: variables.$score-button-score-width;
      vertical-align: middle;
      text-align: center;
    }

    .label {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      font-size: variables.$score-button-font-size;
      font-weight: 500;
      vertical-align: middle;
      padding: 0 10px;
    }
  }
}
